import { createFileRoute } from '@tanstack/react-router'
import { SearchPage } from '../../components/SearchPage'

export const Route = createFileRoute('/$org/search')({
  component: SearchPage,
  validateSearch: (search) => ({
    q: (search.q as string) || '',
    // entity_types parameter is only present when it has a value
    entity_types: search.entity_types as string | undefined,
    // Comma-separated tag codes (uid fallback for a code-less tag) so a
    // tag-filtered search stays bookmarkable — spec 2026-09-05-04.
    tags: search.tags as string | undefined,
    scope: (search.scope as string) || 'properties',
  }),
})